/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x4ad9=['get','ckbox','commands','enableCommand','editor'];(function(_0x363b8d,_0x4ad99f){const _0x5048d3=function(_0x4f9a9f){while(--_0x4f9a9f){_0x363b8d['push'](_0x363b8d['shift']());}};_0x5048d3(++_0x4ad99f);}(_0x4ad9,0x148));const _0x5048=function(_0x363b8d,_0x4ad99f){_0x363b8d=_0x363b8d-0x0;let _0x5048d3=_0x4ad9[_0x363b8d];return _0x5048d3;};import{Plugin as _0x1e1d88}from'ckeditor5/src/core';export default class P extends _0x1e1d88{['afterInit'](){const _0x2b0cba=this[_0x5048('0x1')];_0x2b0cba[_0x5048('0x4')]['get']('ckbox')&&_0x2b0cba['plugins'][_0x5048('0x2')]('TrackChangesEditing')[_0x5048('0x0')](_0x5048('0x3'));}}